module.exports = __webpack_public_path__ + "static/media/software-outsourcing-market.96628084.png";